export const campaignConstants = {
    GETALL_REQUEST: "CAMPAIGNS_GETALL_REQUEST",
    GETALL_SUCCESS: "CAMPAIGNS_GETALL_SUCCESS",
    GETALL_FAILURE: "CAMPAIGNS_GETALL_FAILURE",
    UPDATE_SUCCESS: "CAMPAIGNS_UPDATE_SUCCESS",
    SETDEVS_SUCCESS: "SETDEVS_SUCCESS",
    DIALOG_OPEN: "CAMPAIGN_DIALOG_OPEN",
    DIALOG_CLOSE: "CAMPAIGN_DIALOG_CLOSE",
    CAMPAIGNSIGNUP_REQUEST: "CAMPAIGNSIGNUP_REQUEST"
};

export const CAMPAIGN_STATE = {
    DRAFTED: {
        key: "DRAFTED",
        value: -2,
        color: "#1c99e1",
        groupId: 0
    },
    TOBEREVIEWED: {
        key: "TOBEREVIEWED",
        value: -1,
        color: "#1c99e1",
        groupId: 0
    },
    APPROVED: {
        key: "APPROVED",
        value: 1,
        color: "#1c99e1",
        groupId: 0
    },
    DENIED: {
        key: "DENIED",
        value: 0,
        color: "#1c99e1",
        groupId: 0
    },
    PAUSED: {
        key: "PAUSED",
        value: 4,
        color: "#f3af07",
        groupId: 1
    },
    STARTED: {
        key: "STARTED",
        value: 3,
        color: "#429988",
        groupId: 1
    },
    FINISHED: {
        key: "FINISHED",
        value: 2,
        color: "#656f85",
        groupId: 2
    }
};

export const CAMPAIGN_STATE_GROUP = {
    NOT_STARTED: { key: "NOT_STARTED", id: 0, name: "New", color: "#1c99e1" },
    STARTED: { key: "STARTED", id: 1, name: "Running", color: "#429988" },
    FINISHED: { key: "FINISHED", id: 2, name: "Finished", color: "#656f85" }
};

export const calculateExpectedImpressions = views => {
    return Math.round(Math.round(views * 7.7) / 10) * 10;
};



// WEBPACK FOOTER //
// ./src/_constants/campaign.constants.js